module.exports = __webpack_public_path__ + "static/media/black_icon.bcf6afba.svg";